var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportAppraisalCard.title", {
    count: _vm.report.appraisals.length
  })) + " "), _c('v-spacer'), _c('v-btn', {
    staticClass: "mx-2",
    attrs: {
      "outlined": "",
      "disabled": !_vm.canCreateAppraisal || !_vm.canShareContent
    },
    on: {
      "click": function click($event) {
        _vm.requestDialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportAppraisalCard.request")) + " ")], 1), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "disabled": !_vm.canCreateAppraisal
    },
    on: {
      "click": function click($event) {
        _vm.createDialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-tray-arrow-up")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportAppraisalCard.upload")) + " ")], 1)], 1), _vm.report.isAppraisalLoading ? _c('v-skeleton-loader', {
    staticClass: "mx-4 mb-4",
    attrs: {
      "type": "image"
    }
  }) : _vm.report.appraisals.length === 0 ? _c('v-card-text', [_c('m-no-content', {
    attrs: {
      "icon": "mdi-file-document-outline",
      "text": _vm.$t('components.PartnerReportDetail.repair.PartnerReportAppraisalCard.noAppraisalText')
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('v-btn', {
          staticClass: "mx-2 px-4",
          attrs: {
            "outlined": "",
            "disabled": !_vm.canCreateAppraisal || !_vm.canShareContent
          },
          on: {
            "click": function click($event) {
              _vm.requestDialog = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportAppraisalCard.request")) + " ")], 1), _c('v-btn', {
          staticClass: "mx-2 px-4",
          attrs: {
            "elevation": "0",
            "disabled": !_vm.canCreateAppraisal
          },
          on: {
            "click": function click($event) {
              _vm.createDialog = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-tray-arrow-up")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportAppraisalCard.upload")) + " ")], 1)];
      },
      proxy: true
    }])
  })], 1) : _c('div', {
    staticClass: "mx-4"
  }, [_c('v-divider'), _c('v-tabs', {
    staticClass: "custom-tabs",
    attrs: {
      "background-color": "transparent",
      "show-arrows": "",
      "slider-color": "transparent",
      "active-class": "custom-tab--active"
    },
    model: {
      value: _vm.activeAppraisal,
      callback: function callback($$v) {
        _vm.activeAppraisal = $$v;
      },
      expression: "activeAppraisal"
    }
  }, _vm._l(_vm.report.appraisals, function (appraisal, index) {
    var _appraisal$timestamp;

    return _c('v-tab', {
      key: 'tab-' + index,
      attrs: {
        "value": index
      }
    }, [_vm._v(" " + _vm._s((appraisal.title || "#" + (index + 1)) + ((_appraisal$timestamp = appraisal.timestamp) !== null && _appraisal$timestamp !== void 0 && _appraisal$timestamp.createdReadable ? " (" + appraisal.timestamp.createdReadable + ")" : "")) + " ")]);
  }), 1), _c('v-sheet', {
    attrs: {
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    }
  }, [_c('v-card-text', [_c('v-tabs-items', {
    model: {
      value: _vm.activeAppraisal,
      callback: function callback($$v) {
        _vm.activeAppraisal = $$v;
      },
      expression: "activeAppraisal"
    }
  }, _vm._l(_vm.report.appraisals, function (_, index) {
    return _c('v-tab-item', {
      key: 'tab-content-' + index,
      attrs: {
        "value": index
      }
    }, [_c('appraisal-sheet', {
      attrs: {
        "appraisal": _vm.report.appraisals[index],
        "report": _vm.report
      },
      on: {
        "update:appraisal": function updateAppraisal($event) {
          return _vm.$set(_vm.report.appraisals, index, $event);
        },
        "delete": function _delete($event) {
          return _vm.removeFromReport(index);
        }
      }
    })], 1);
  }), 1)], 1)], 1)], 1), _c('report-appraisal-request-dialog', {
    model: {
      value: _vm.requestDialog,
      callback: function callback($$v) {
        _vm.requestDialog = $$v;
      },
      expression: "requestDialog"
    }
  }), _c('report-appraisal-create-dialog', {
    model: {
      value: _vm.createDialog,
      callback: function callback($$v) {
        _vm.createDialog = $$v;
      },
      expression: "createDialog"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }